<div class="alert alert-info" *ngIf="getInstructions().length > 0">
    <span [innerHTML]="getInstructions()"></span>
</div>
<span>
    <div class="form-inline pl-4" *ngIf="currentUser.value.roles.academicHumanResources; else nonAHR">
        <span class="mr-2"><strong>Review Cycle:</strong></span>
        <select class="form-control" style="min-width: 200px;" [(ngModel)]="selectedAHRYear" (change)="refreshComponent(selectedAHRYear)">
            <option *ngFor="let ahrYear of ahrYears" [ngValue]="ahrYear.value">{{ahrYear.displayValue}}</option>
        </select>
    </div>
    <ng-template #nonAHR>
        <div class="pl-4">
            <strong>Review Cycle: </strong>{{ getReviewRange(selectedAHRYear) }}
        </div>
    </ng-template>
    <hr/>
</span>

<div id="wrapper" class="container-fluid">
    <div class="row">
        <div class="col-lg-4 mb-3">
            <reviewer-case-list *ngIf="showCaseList" [selectedAHRYear]="selectedAHRYear"></reviewer-case-list>
        </div>
        <div class="col-md-12 col-lg-8">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
